import styled from "styled-components";
export const ContainerEditarOrden = styled.div`
  width: 400px;
  height: 700px;
  @media (max-width: 700px) {
    width: 360px;
  }
  @media (max-height: 700px) {
    height: 580px;
  }
  border-radius: 8px;
`;

export const ContainerTop = styled.div`
  height: 63px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  span {
    color: var(--color-white);
    font-size: 18px;
    font-weight: bold;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  .cruz {
    margin-top: 4px;
  }
`;

export const ContainerBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span {
    font-size: 18px;
    font-weight: bold;
  }
  .image-current {
    height: 300px;
    width: 300px;
    border-radius: 8px;
    object-fit: contain;
  }
  height: calc(100% - 63px);
  .success {
    background: var(--color-broccoli);
    color: var(--color-white);
    font-size: 18px;
    font-weight: bold;
  }
  .danger {
    background-color: var(--color-danger);
    color: var(--color-white);
    font-size: 18px;
    font-weight: bold;
  }
  .container-subir-orden {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .autocheckin-absolute {
    background-color: red;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  .btn-validaturno {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }
  .container-question {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  .container-btn {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }
`;
